import { Paper, Stack, Box, ThemeIcon, Text } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const SuccessCard: React.FC = (props) => {
  const { t } = useTranslation();

  return (
    <Paper p="xl" radius="md">
      <Stack align="center">
        <Box bg="pf-green.1" p="md" style={{ borderRadius: '50%' }}>
          <ThemeIcon color="pf-green.6" radius="xl" size={60} variant="filled">
            <IconCheck size={24} />
          </ThemeIcon>
        </Box>
        <Text fw="bold" size="xl">
          {t('farmer-validation.success-header')}
        </Text>
        <Text c="dimmed" ta="center">
          {t('farmer-validation.success-body')}
        </Text>
      </Stack>
    </Paper>
  );
};
